import { Logger } from '~/helpers/logger';
import { VsfContext } from '~/composables/context';
import DOMPurify from 'isomorphic-dompurify';

export const loadContentCommand = {
  execute: async (context: VsfContext, params) => {
    const identifier = DOMPurify.sanitize(params.identifier);

    Logger.debug('[Magento]: Load CMS Page content', { params });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const { data } = await context.$magento.api.cmsPage(identifier, params.customQuery ?? null, params?.customHeaders);

    Logger.debug('[Result]:', { data });

    return data.cmsPage;
  },
};
